/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PhoneNumberBody } from './PhoneNumberBody';
import {
    PhoneNumberBodyFromJSON,
    PhoneNumberBodyFromJSONTyped,
    PhoneNumberBodyToJSON,
    PhoneNumberBodyToJSONTyped,
} from './PhoneNumberBody';

/**
 * 
 * @export
 * @interface UpdateProfileBody
 */
export interface UpdateProfileBody {
    /**
     * 
     * @type {PhoneNumberBody}
     * @memberof UpdateProfileBody
     */
    phoneNumber?: PhoneNumberBody;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    ordersEmail?: string;
    /**
     * 
     * @type {PhoneNumberBody}
     * @memberof UpdateProfileBody
     */
    ordersPhoneNumber?: PhoneNumberBody;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    ordersFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    ordersLastName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProfileBody
     */
    silentDupeChecks?: boolean;
    /**
     * Unix ms. Write-once — set it if you have not already; changing it afterwards requires support, because an age gate you can edit is not a gate.
     * @type {number}
     * @memberof UpdateProfileBody
     */
    dateOfBirth?: number;
}

/**
 * Check if a given object implements the UpdateProfileBody interface.
 */
export function instanceOfUpdateProfileBody(value: object): value is UpdateProfileBody {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function UpdateProfileBodyFromJSON(json: any): UpdateProfileBody {
    return UpdateProfileBodyFromJSONTyped(json, false);
}

export function UpdateProfileBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProfileBody {
    if (json == null) {
        return json;
    }
    return {
        
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberBodyFromJSON(json['phoneNumber']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'ordersEmail': json['ordersEmail'] == null ? undefined : json['ordersEmail'],
        'ordersPhoneNumber': json['ordersPhoneNumber'] == null ? undefined : PhoneNumberBodyFromJSON(json['ordersPhoneNumber']),
        'ordersFirstName': json['ordersFirstName'] == null ? undefined : json['ordersFirstName'],
        'ordersLastName': json['ordersLastName'] == null ? undefined : json['ordersLastName'],
        'silentDupeChecks': json['silentDupeChecks'] == null ? undefined : json['silentDupeChecks'],
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : json['dateOfBirth'],
    };
}

export function UpdateProfileBodyToJSON(json: any): UpdateProfileBody {
    return UpdateProfileBodyToJSONTyped(json, false);
}

export function UpdateProfileBodyToJSONTyped(value?: UpdateProfileBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phoneNumber': PhoneNumberBodyToJSON(value['phoneNumber']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'ordersEmail': value['ordersEmail'],
        'ordersPhoneNumber': PhoneNumberBodyToJSON(value['ordersPhoneNumber']),
        'ordersFirstName': value['ordersFirstName'],
        'ordersLastName': value['ordersLastName'],
        'silentDupeChecks': value['silentDupeChecks'],
        'dateOfBirth': value['dateOfBirth'],
    };
}

